// @ts-check
/**
 * @prettier
 */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _orderBy from 'lodash/orderBy';
import { getCardSettings } from 'cards/util/cardSettingsUtils';

import getImageFromDraft from '../tools/getImageFromDraft';
import { getLastUpdatedDate, dateToLastUpdateDateString } from '../tools/dateTools';
import useImageOrientation from '../../../../../../helpers/hooks/useImageOrientation';

// @ts-ignore
import styles from './SingleDraft.module.less';

const SingleDraft = ({ draft }) => {
  const imgSrc = getImageFromDraft(draft);
  const { loading, orientation } = useImageOrientation(imgSrc);
  const imageClasses = cx(
    styles.image,
    { [styles.evenImage]: loading || orientation === 'even' },
    { [styles.portraitImage]: orientation === 'portrait' },
    { [styles.landscapeImage]: orientation === 'landscape' }
  );
  return (
    <>
      <p className={styles.lastUpdated}>
        Last Updated: {dateToLastUpdateDateString(getLastUpdatedDate(draft))}
      </p>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <img className={imageClasses} src={imgSrc} alt={draft.project_name} />
        </div>
        <div className={styles.customizationsContainer}>
          {_orderBy(draft.customizations, 'lead', 'desc')
            .filter(({ type }) => type !== 'ENVELOPE')
            .map(customization => (
              <div key={customization.project_customization_uuid} className={styles.customization}>
                <p className={styles.title}>{getCardSettings(customization.type).label}</p>
                <p className={styles.amount}>{customization.quantity} Cards</p>
                <p className={styles.label}>
                  <b>Type: </b>
                  {customization.medium === 'PAPER' && 'Paper'}
                  {customization.medium === 'MAGNET' && 'Magnet'}
                </p>
                {customization.catalog_item_view.product_option_value_labels.size && (
                  <p className={styles.label}>
                    <b>Size: </b>
                    {customization.catalog_item_view.product_option_value_labels.size}
                  </p>
                )}
                {customization.catalog_item_view.product_option_value_labels.foil && (
                  <p className={styles.label}>
                    <b>Custom Foil: </b>
                    {customization.catalog_item_view.product_option_value_labels.foil === 'None'
                      ? 'No Foil'
                      : customization.catalog_item_view.product_option_value_labels.foil}
                  </p>
                )}
                {customization.catalog_item_view.product_option_value_labels['paper-type'] && (
                  <p className={styles.label}>
                    <b>Paper Type: </b>
                    {customization.catalog_item_view.product_option_value_labels['paper-type']}
                  </p>
                )}
                {customization.catalog_item_view.product_option_value_labels.silhouette && (
                  <p className={styles.label}>
                    <b>Silhouette: </b>
                    {customization.catalog_item_view.product_option_value_labels.silhouette}
                  </p>
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

SingleDraft.propTypes = {
  draft: PropTypes.shape({}).isRequired,
};

export default SingleDraft;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/components/SingleDraft.jsx